"use strict";

import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var caret = _7a468({
  defaultClassName: "Tooltip_caret__1supyn2o",
  variantClassNames: {
    position: {
      top: "Tooltip_caret_position_top__1supyn2p",
      right: "Tooltip_caret_position_right__1supyn2q",
      bottom: "Tooltip_caret_position_bottom__1supyn2r",
      left: "Tooltip_caret_position_left__1supyn2s"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var caretLeft = "var(--caretLeft__1supyn2n)";
export var caretSize = "var(--caretSize__1supyn2i)";
export var caretTop = "var(--caretTop__1supyn2m)";
export var content = _7a468({
  defaultClassName: "Tooltip_content__1supyn2t",
  variantClassNames: {
    size: {
      small: "Tooltip_content_size_small__1supyn2u",
      large: "Tooltip_content_size_large__1supyn2v"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var left = "var(--left__1supyn22)";
export var tooltip = _7a468({
  defaultClassName: "Tooltip_tooltip__1supyn25",
  variantClassNames: {
    size: {
      small: "Tooltip_tooltip_size_small__1supyn26",
      large: "Tooltip_tooltip_size_large__1supyn27"
    },
    position: {
      top: "Tooltip_tooltip_position_top__1supyn28",
      right: "Tooltip_tooltip_position_right__1supyn29",
      bottom: "Tooltip_tooltip_position_bottom__1supyn2a",
      left: "Tooltip_tooltip_position_left__1supyn2b"
    },
    error: {
      true: "Tooltip_tooltip_error_true__1supyn2c"
    },
    status: {
      entering: "Tooltip_tooltip_status_entering__1supyn2d",
      entered: "Tooltip_tooltip_status_entered__1supyn2e",
      exiting: "Tooltip_tooltip_status_exiting__1supyn2f",
      exited: "Tooltip_tooltip_status_exited__1supyn2g",
      unmounted: "Tooltip_tooltip_status_unmounted__1supyn2h"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var top = "var(--top__1supyn21)";
export var wrapper = "Tooltip_wrapper__1supyn20";